import React from "react";
import { Container, Card, Button, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const PageNotFound = () => {
  const navigate = useNavigate();

  const handleRedirect = () => {
    navigate("/sites");
  };

  return (
    <Container
      fluid
      className="d-flex justify-content-center align-items-center vh-100 login-container"
    >
      <Row className="w-100 justify-content-center">
        <Col xs={12} sm={10} md={8} lg={6} xl={5}>
          <Card className="border-0 rounded-3 shadow-lg bg-white">
            <Card.Body className="text-center p-5">
              <h1 className="display-1 text-muted mb-3">404</h1>
              <h2 className="fw-light text-muted mb-4">Page Not Found</h2>
              <p className="text-muted mb-4 lead">
                The page you are looking for does not exist.
              </p>
              <Button
                size="lg"
                className="rounded-pill px-4 py-2"
                onClick={handleRedirect}
              >
                <i className="bi bi-house-door me-2"></i>
                Return to Homepage
              </Button>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default PageNotFound;
